<!--Tenders results view-->
<router-outlet></router-outlet>
